module.exports = __webpack_public_path__ + "img/app-store.a5bc15d1.svg";